// extracted by mini-css-extract-plugin
export default {"container":"container__YB_n38D8"};